module.exports = __webpack_public_path__ + "static/media/decorator-circle-orange.409604d6.svg";